import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '../DialogTitle';
import DialogHeader from '../DialogHeader';

function ResponsiveDialogHeader(props) {
    return (
        <React.Fragment>
            {props.fullScreen &&
                <DialogHeader title={props.fullScreenTitle || props.title} {...props}></DialogHeader>
            }
            {!props.fullScreen &&
                <DialogTitle {...props}>
                    {props.title}
                </DialogTitle>
            }
        </React.Fragment>
    );
}

ResponsiveDialogHeader.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    handleClose: PropTypes.func.isRequired,
    fullScreenTitle: PropTypes.string,
    showBackIcon: PropTypes.bool,
    disableClose: PropTypes.bool
};

export default ResponsiveDialogHeader;